import type { UserRoles } from "./userRoles";

/**
 * Single source of truth for role → path mapping after login.
 * Used by AuthProvider for redirect-on-sign-in and exposed via context.
 */
export function getRedirectPathForRole(role: UserRoles | null): string {
  if (role === "admin") return "/clinical-coding/coding-dashboard";
  if (role === "clinical_coder" || role === "clinical_coder_admin") {
    return "/clinical-coding/ai-coding-outputs";
  }
  return "/no-role";
}
